// src/components/insights/CitationContext.js

import { createContext, useContext, useRef } from "react";

const CitationContext = createContext();

export function CitationProvider({ children, references = {} }) {
  const mapRef = useRef({});
  const orderRef = useRef([]);

  const getNumber = (id) => {
    if (!mapRef.current[id]) {
      mapRef.current[id] = orderRef.current.length + 1;
      orderRef.current.push(id);
    }
    return mapRef.current[id];
  };

  const getReference = (id) => references[id];

  return (
    <CitationContext.Provider
      value={{
        getNumber,
        orderedIds: orderRef.current,
        getReference,
      }}
    >
      {children}
    </CitationContext.Provider>
  );
}

/* 👇 AIXÒ FALTAVA */
export function useCitationContext() {
  return useContext(CitationContext);
}